export const COOKIES = ['fr', 'datr', 'sb', 'wd', '_fbp'];

export const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
